import * as React from 'react';

import { createIcon } from '../Icon';
export const SkipBackIcon = createIcon(
  <React.Fragment>
    <polygon points="19 20 9 12 19 4 19 20" />
    <line x1={5} y1={19} x2={5} y2={5} />
  </React.Fragment>,
  'SkipBackIcon'
);
